"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.canSaveIntegrationSettings = exports.WidgetSelection = exports.WidgetPreview = exports.IntegrationDescription = exports.AdditionalConfigurations = void 0;

var _preact = require("preact");

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _DropdownControl = _interopRequireDefault(require("@insided/shared/uikit/dropdown/DropdownControl"));

var _Autopilot = _interopRequireDefault(require("../../../../destination/modules/Autopilot"));

var _Info = _interopRequireDefault(require("@insided/control/icons/Info"));

var WidgetSelection = function WidgetSelection(_ref) {
  var _widgets$find$name, _widgets$find;

  var widgets = _ref.widgets,
      selectedWidget = _ref.selectedWidget,
      onWidgetChange = _ref.onWidgetChange,
      widgetsError = _ref.widgetsError,
      isLoadingWidgets = _ref.isLoadingWidgets;

  var normalizeWidgets = function normalizeWidgets() {
    return [{
      title: 'Select a widget',
      value: '',
      onClick: function onClick() {
        return onWidgetChange('');
      }
    }].concat((0, _toConsumableArray2.default)(widgets.map(function (widget) {
      return {
        title: widget.name,
        value: widget.id,
        onClick: function onClick() {
          return onWidgetChange(widget.id);
        }
      };
    })));
  };

  return (0, _preact.h)("div", {
    className: "integration-field-wrapper"
  }, (0, _preact.h)("div", {
    className: "widget-selection-label",
    style: {
      marginTop: '32px'
    }
  }, "Widget Selection"), (0, _preact.h)("div", {
    className: "widget-selection-description"
  }, "Select a widget from your connected TheLoops account."), widgetsError && (0, _preact.h)("div", {
    className: "widgets-error-message"
  }, widgetsError), !isLoadingWidgets && !widgetsError && widgets.length === 0 ? (0, _preact.h)("div", {
    className: "widgets-error-message"
  }, "No widgets found.") : (0, _preact.h)(_DropdownControl.default, {
    closeOnDropdownClick: true,
    align: "adjust",
    triggerClass: "loop_dropdown",
    items: normalizeWidgets(),
    trigger: (0, _preact.h)(_Button.default, {
      icon: "chevronDown",
      title: (_widgets$find$name = (_widgets$find = widgets.find(function (widget) {
        return widget.id === selectedWidget;
      })) === null || _widgets$find === void 0 ? void 0 : _widgets$find.name) !== null && _widgets$find$name !== void 0 ? _widgets$find$name : 'Select a widget',
      style: {
        width: '352px',
        height: '40px'
      },
      className: "loops-dropdowns"
    })
  }));
};

exports.WidgetSelection = WidgetSelection;

var WidgetPreview = function WidgetPreview(_ref2) {
  var _widgetDetails$id;

  var previewWidth = _ref2.previewWidth,
      widgetDetails = _ref2.widgetDetails,
      loopsTenantId = _ref2.loopsTenantId,
      _ref2$isFromControl = _ref2.isFromControl,
      _isFromControl = _ref2$isFromControl === void 0 ? true : _ref2$isFromControl;

  return (0, _preact.h)("div", {
    className: "integration-field-wrapper"
  }, (0, _preact.h)("div", null, "Preview"), (0, _preact.h)("div", {
    className: "preview-wrapper",
    style: {
      height: '650px',
      width: previewWidth ? "".concat(previewWidth, "px") : '566px'
    }
  }, (0, _preact.h)("div", {
    style: {
      height: '618px',
      width: '100%'
    }
  }, (0, _preact.h)(_Autopilot.default, {
    tenantId: loopsTenantId,
    userId: "anonymous",
    userEmail: "random.user@example.com",
    widgetId: (_widgetDetails$id = widgetDetails === null || widgetDetails === void 0 ? void 0 : widgetDetails.id) !== null && _widgetDetails$id !== void 0 ? _widgetDetails$id : '',
    widgetWidth: "100%",
    widgetHeight: "100%",
    customCss: "",
    cdnPrefix: "dist/",
    parentHeight: "618px",
    isFromControl: true
  }))));
};

exports.WidgetPreview = WidgetPreview;

var AdditionalConfigurations = function AdditionalConfigurations(_ref3) {
  var showAutopilotNavbar = _ref3.showAutopilotNavbar,
      onAutopilotNavbarChange = _ref3.onAutopilotNavbarChange;
  return (0, _preact.h)("div", null, (0, _preact.h)("div", {
    className: "integration-field-wrapper"
  }, (0, _preact.h)("div", {
    className: "widget-selection-label"
  }, "Additional Configurations")), (0, _preact.h)("div", {
    className: "panel-form-information panel-form-information--info",
    style: {
      marginTop: '16px',
      marginBottom: '16px'
    }
  }, (0, _preact.h)("div", {
    className: "panel-form-information__icon-box"
  }, (0, _preact.h)(_Info.default, {
    width: 20,
    height: 20,
    fill: "#6B7280"
  })), (0, _preact.h)("div", {
    className: "panel-form-text"
  }, "You can enable a shortcut to TheLoops AI Answer agent and configure additional widgets and enable widgets like the \"AI Search Widget\" from here.", ' ', (0, _preact.h)("a", {
    href: "https://help.insided.com/theloops-integration-guide",
    className: "external-link"
  }, "Learn More"))), (0, _preact.h)("div", {
    className: "integration-field-wrapper"
  }, (0, _preact.h)("label", {
    className: "checkbox-label"
  }, (0, _preact.h)("input", {
    type: "checkbox",
    className: "integration-checkbox-field",
    id: "ai-agent-shortcut",
    name: "ai-agent-shortcut",
    checked: showAutopilotNavbar,
    onChange: onAutopilotNavbarChange
  }), ' ', "Show AI Agent Shortcut in Mega Menu")));
};

exports.AdditionalConfigurations = AdditionalConfigurations;

var IntegrationDescription = function IntegrationDescription(_ref4) {
  var isInstalled = _ref4.isInstalled,
      onCompleteInstallation = _ref4.onCompleteInstallation;
  return (0, _preact.h)("div", null, isInstalled ? 'Empower end users to ask questions and start conversations with AI Answer Agent' : 'Complete the installation to enable users to ask questions and get instant answers from the AI Answer Agent.', !isInstalled && (0, _preact.h)("div", {
    style: {
      marginTop: '16px'
    }
  }, (0, _preact.h)(_Button.default, {
    variant: "brand",
    size: "medium",
    onClick: onCompleteInstallation
  }, "Complete Installation")));
};

exports.IntegrationDescription = IntegrationDescription;

var canSaveIntegrationSettings = function canSaveIntegrationSettings(selectedWidget, showAutopilotNavbar, enabled, lastSavedSelectedWidget, lastSavedShowAutopilotNavbar, lastSavedIsEnabled) {
  var hasChanges = selectedWidget !== lastSavedSelectedWidget || showAutopilotNavbar !== lastSavedShowAutopilotNavbar || enabled !== lastSavedIsEnabled;
  var hasValidWidget = (selectedWidget === null || selectedWidget === void 0 ? void 0 : selectedWidget.trim()) !== ''; // If there are changes and widget is disabled, allow saving
  // If widget is enabled, require a valid widget selection

  return hasChanges && (!enabled || hasValidWidget);
};

exports.canSaveIntegrationSettings = canSaveIntegrationSettings;